import { Link } from "react-router-dom";
import { Instagram, Phone } from "lucide-react";
import { ASSETS, BRAND } from "@/lib/brand";
import { NewsletterSignup } from "@/components/NewsletterSignup";

export function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-void/50 backdrop-blur-md pt-20 pb-10 px-5 md:px-10">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-6">
            <img src={ASSETS.logoRound} alt="Exotic Reefing Inc" className="w-16 h-16 rounded-full object-cover ring-1 ring-cyan/30" />
            <div>
              <h3 className="font-display text-2xl leading-none text-cyan">Exotic Reefing Inc</h3>
              <p className="text-white/40 text-xs mt-1">{BRAND.tagline}</p>
            </div>
          </div>
          <p className="font-display italic text-2xl text-white/70 mb-6">"{BRAND.slogan}"</p>
          <a href={BRAND.phoneHref} data-testid="footer-phone" className="inline-flex items-center gap-2 text-cyan hover:text-white transition-colors font-mono">
            <Phone size={16} /> {BRAND.phone}
          </a>
          <p className="text-white/40 text-sm mt-4">{BRAND.serving}</p>
          <div className="mt-8">
            <p className="mono-label mb-2 text-cyan">Get 10% off + new-arrival alerts</p>
            <p className="text-white/50 text-sm mb-3 max-w-md">Subscribe for first access to new corals, fish & merch, plus holiday specials and promo codes.</p>
            <NewsletterSignup />
          </div>
        </div>
        <div>
          <p className="mono-label mb-5">Explore</p>
          <ul className="space-y-3 text-white/60 text-sm">
            <li><Link to="/shop" className="hover:text-cyan transition-colors">Shop Corals & Fish</Link></li>
            <li><Link to="/auctions" className="hover:text-cyan transition-colors">Live Auctions</Link></li>
            <li><Link to="/services" className="hover:text-cyan transition-colors">Services & Booking</Link></li>
            <li><Link to="/pricing" className="hover:text-cyan transition-colors">Pricing</Link></li>
            <li><Link to="/wholesale" className="hover:text-cyan transition-colors">Wholesale</Link></li>
            <li><Link to="/reviews" className="hover:text-cyan transition-colors">Reviews</Link></li>
            <li><Link to="/policy" className="hover:text-cyan transition-colors">Shipping & DOA Policy</Link></li>
            <li><Link to="/privacy" className="hover:text-cyan transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-cyan transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/admin/login" className="hover:text-cyan transition-colors">Admin</Link></li>
          </ul>
        </div>
        <div>
          <p className="mono-label mb-5">Follow</p>
          <div className="flex flex-col gap-3 text-white/60 text-sm">
            <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="social-instagram"
              className="flex items-center gap-3 hover:text-reefpink transition-colors">
              <Instagram size={18} /> {BRAND.instagramHandle}
            </a>
            <a href={BRAND.tiktok} target="_blank" rel="noreferrer" data-testid="social-tiktok"
              className="flex items-center gap-3 hover:text-cyan transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M16.5 3c.4 2.5 1.9 4.1 4.5 4.3v2.9c-1.5.1-2.9-.3-4.3-1.1v6.3c0 4-2.9 6.6-6.3 6.6-3.3 0-5.4-2.3-5.4-5.1 0-3.1 2.4-5.3 5.6-5.1v3c-.5-.1-1-.1-1.4 0-1.2.3-1.9 1.1-1.8 2.3.1 1.2 1 1.9 2.2 1.8 1.3-.1 2.1-1 2.1-2.6V3h4.5z"/></svg>
              TikTok
            </a>
          </div>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-white/30 text-xs font-mono">
        <span>© {new Date().getFullYear()} EXOTIC REEFING INC.</span>
        <span>SALTWATER LIVESTOCK • AQUACULTURE • MAINTENANCE • SOUTH FLORIDA</span>
      </div>
    </footer>
  );
}
